
import { MerchantInfo, MerchantState } from '../../../type';

/**
 * 解析商户值
 * @param data
 * @returns
 */
export function resolveMerchantInfo(data): MerchantInfo | null {
  if (!data) {
    return null;
  }
  return {
    /**
   * 商户ID
   */
    spId: data.spid || '',
    /**
   * logo地址
   */
    spLogo: data.sp_logo ? decodeURIComponent(data.sp_logo) : '',
    /**
   * 商户名
   */
    spName: data.sp_name || '',
    /**
   * 商户展示券累计折扣总值
   */
    totalValue: data.total_value || '0',
    /**
   * 商户名下是有可领展示券
   */
    state: resolveState(data.tState),
  };
}

/**
 * 解析商户状态类型
 * @param state 状态值
 * @returns
 */
function resolveState(state: string) {
  switch (`${state}`) {
    /** 可领取（存在该用户未领取，且未派完的券） */
    case '1':
      return MerchantState.Normal;
    case '2':
      /** 已领取 */
      return MerchantState.Got;
    /** 已领完 */
    case '3':
      return MerchantState.Empty;
    /** 已使用 */
    case '4':
    default:
      return MerchantState.None;
  }
}

/**
 * 获取分类下商户列表信息
 * @param classId 商户分类ID
 * @returns
 */
export function getMerchantList(classId: string): MerchantInfo[] {
  console.log(classId);
  return [];
}

/**
 * 领取商户下所有券
 * @param spId 商户ID
 * @returns
 */
export function execAllCoupons(spId: string) {
  console.log(spId);
  return true;
}
